import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

const linkStyle = {
  color: '#1677ff',
  textDecoration: 'none',
};

const EntityLink = ({ to, enabled = true, children, style, ...rest }) => {
  if (!to || enabled === false) {
    return children ?? null;
  }

  return (
    <Link to={to} style={{ ...linkStyle, ...style }} {...rest}>
      {children}
    </Link>
  );
};

EntityLink.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  enabled: PropTypes.bool,
  children: PropTypes.node,
  style: PropTypes.object,
};

export default EntityLink;
